import { cn } from "@newxsystems/shared";
import { RavioliAction } from "../RavioliAction/RavioliAction";
import { RavioliMedia } from "../RavioliMedia/RavioliMedia";
import { RavioliRichText } from "../RavioliRichText/RavioliRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-5", centered && "items-center text-center")}>
      {eyebrow ? (
        <p className="inline-flex w-fit items-center gap-2 border border-canvas/60 px-3 py-1.5 font-ravioli-body text-[0.8125rem] font-semibold before:block before:size-1.5 before:bg-canvas">
          {eyebrow}
        </p>
      ) : null}
      {image ? (
        <RavioliMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-4 border-4 border-canvas", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="font-ravioli-display text-5xl font-semibold leading-[0.96] tracking-[-0.02em] text-balance [overflow-wrap:break-word] md:text-7xl">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <RavioliRichText className="max-w-[65ch] text-canvas" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <RavioliAction
              action={button}
              className="border-canvas bg-canvas text-primary"
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
